import addresses from 'config/constants/contracts'
import tokens from 'config/constants/tokens'
import { Address } from 'config/constants/types'

export const getAddress = (address: Address): string => {
  const chainId = process.env.REACT_APP_CHAIN_ID
  return address[chainId] ? address[chainId] : address[250]
}

export const getDmdAddress = () => {
  return getAddress(tokens.dmd.address)
}
export const getMasterChefAddress = () => {
  return getAddress(addresses.masterChef)
}
export const getMulticallAddress = () => {
  return getAddress(addresses.multiCall)
}
export const getWftmAddress = () => {
  return getAddress(tokens.wftm.address)
}
export const getNftKeyAddress = () => {
  return getAddress(addresses.nftkey)
}
export const getNftMultiTransferAddress = () => {
  return getAddress(addresses.nftMultiTransfer)
}
export const getPresaleAddress = () => {
  return getAddress(addresses.presale)
}
export const getWant = () => {
  return getAddress(addresses.want)
}
export const getDmdvaultAddress = () => {
  return getAddress(addresses.dmdvault)
}
export const getZapAddress = () => {
  return getAddress(addresses.zap)
}
export const getLotteryAddress = () => {
  return getAddress(addresses.lottery)
}
export const getSpookySwapAddress = () => {
  return getAddress(addresses.spookySwap)
}
export const getNftLaunchpadFactoryV2Address = () => {
  return getAddress(addresses.nftLaunchpadFactoryV2)
}
export const getNftLaunchpadFactoryAddress = () => {
  return getAddress(addresses.nftLaunchpadFactory)
}
